const NATIVE_GENERIC_FAMILIES = new Set(['system-ui', 'sans-serif', 'serif', 'monospace', 'cursive']);

/** First font in a CSS stack when it is not a generic keyword (candidate for Google Fonts). */
export function getFirstFontFamily(fullFontText: string | undefined): string | undefined {
  if (!fullFontText) return undefined;
  const first = fullFontText.split(',')[0].trim();
  if (!first || NATIVE_GENERIC_FAMILIES.has(first)) return undefined;
  return first;
}

export function buildGoogleFontUrl(families: string[]): string {
  const url = new URL('https://fonts.googleapis.com/css2');
  for (const f of families) {
    url.searchParams.append('family', `${f}:wght@400;500;600;700`);
  }
  url.searchParams.set('display', 'swap');
  return url.toString();
}
